import { render, staticRenderFns } from "./materialScience_line.vue?vue&type=template&id=37051733&scoped=true"
import script from "./materialScience_line.vue?vue&type=script&lang=js"
export * from "./materialScience_line.vue?vue&type=script&lang=js"
import style0 from "./materialScience_line.vue?vue&type=style&index=0&id=37051733&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37051733",
  null
  
)

export default component.exports